var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_danger",
    "data-name": "vuesax/bulk/danger",
    transform: "translate(-428 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2,13.92,13.8,2.4A3.987,3.987,0,0,0,10.44,0,3.987,3.987,0,0,0,7.08,2.4L.68,13.92a3.96,3.96,0,0,0-.25,3.99,3.936,3.936,0,0,0,3.61,1.72h12.8a3.936,3.936,0,0,0,3.61-1.72A3.959,3.959,0,0,0,20.2,13.92Z",
    transform: "translate(429.56 254)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.75,6.5A.755.755,0,0,1,0,5.75v-5A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v5A.755.755,0,0,1,.75,6.5Z",
    transform: "translate(439.25 260.25)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1,2a1.5,1.5,0,0,1-.2-.02.636.636,0,0,1-.18-.06.757.757,0,0,1-.18-.09l-.15-.12A1.052,1.052,0,0,1,0,1,1.052,1.052,0,0,1,.29.293L.44.172A.757.757,0,0,1,.62.082.636.636,0,0,1,.8.022a.856.856,0,0,1,.39,0,.6.6,0,0,1,.19.06.757.757,0,0,1,.18.09l.15.12A1.052,1.052,0,0,1,2,1a1.052,1.052,0,0,1-.29.71l-.15.12a.757.757,0,0,1-.18.09.6.6,0,0,1-.19.06A1.225,1.225,0,0,1,1,2Z",
    transform: "translate(439 267.997)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 252)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.13eb4189c35abdcd4673e3c4c28443af.svg";
export { ForwardRef as ReactComponent };